<template>
  <div class="DRecommendTopic">
    <DListTitle
      title="专辑推荐"
      icon-type="topic"
    />
    <div class="topic-list">
      <div
        v-for="(vo,idx) in topicList"
        :key="idx"
        :title="vo.title"
        class="topic-item"
      >
        <img
          :src="PAGE_PATH.BASE_IMG_URL + '/' + vo.pic_url"
          :title="vo.title"
          class="swiper-img"
        >
        <TupianMask :link="vo.link_url" />
      </div>
    </div>
  </div>
</template>

<script>
import DListTitle from '@/components/3d/d-list/d-list-title'
import { PAGE_PATH } from '@/constant/PAGE_PATH'
import TupianMask from '@/components/tupian/tupian-mask'

export default {
  name: "DRecommendTopic",
  components:{
    DListTitle,
    TupianMask
  },
  props:{
    topicList:{
      type: Array,
      default:()=>[
        {
          label:1
        }
      ]
    }
  },
  data(){
    return{
      PAGE_PATH
    }
  }
}
</script>

<style lang="scss" scoped>
.DRecommendTopic{

  .topic-list{
    display: flex;
    margin-top: 32px;

    .topic-item{
      width: 256px;
      height: 360px;
      overflow: hidden;
      border-radius: 14px;
      margin-right: 36px;
      position: relative;
      &:last-child{
        margin-right: 0;
      }
      @include ElementHover('', '') {
        img {
          transform: scale(1.1);
        }
      }
      img{
        display: inline-block;
        width: 100%;
        height: 100%;
        transition: all 0.5s ease-in-out;
      }
    }
  }

  @include Screen(1){

    .topic-list{
      .topic-item{
        width: 214px;
        height: 300px;
        margin-right: 30px;
      }
    }
  }
}
</style>
